import { Routes, Route } from "react-router-dom";
import Login from "../pages/Login";
import Admins from "../pages/Admins";
import Perfil from "../pages/Perfil";
import HomePage from "../pages/HomePage";
import Clientes from "../pages/Clientes";
import Reuniones from "../pages/Reuniones";
import Dashboard from "../pages/Dashboard";
import Contadores from "../pages/Contadores";
import NotFound from "../pages/404/NotFound";
import EmpresaList from "../pages/EmpresaList";
import MenuDoc from "../pages/clients/MenuDoc";
import PrivateRoute from "../auth/PrivateRoute";
import Empresas from "../pages/clients/Empresas";
import Documentos from "../pages/clients/Documentos";
import EmpresasContador from "../pages/contador/EmpresasContador";
import OrganigramaPage from "../pages/Organigrama";
import UsuariosRS from "../pages/UsuariosRS";
import Encuesta from "../pages/Encuesta";
import EmpresasContadorAdminTemplate from "../components/templates/contadores/EmpresasContadorAdminTemplate";
import EstadoDeCuenta from "../pages/clients/EstadoDeCuenta";
import Anuncios from "../pages/Anuncios";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import Usuarios from "../pages/Usuarios";
import AvisosYBlog from "../pages/AvisosYBlog";
import Herramientas from "../pages/clients/Herramientas";
import EmpresasAdmin from "../pages/EmpresasAdmin";
import Leaders from "../pages/Leaders";
import EmpresaDecide from "../pages/clients/EmpresaDecide";
import DF from "../pages/clients/DF/DF";
import DFMenu from "../pages/clients/DF/DFMenu";
import DFEtapa from "../pages/clients/DF/DFEtapa";
import Abogados from "../pages/Abogados";
import EmpresasByAdmin from "../pages/EmpresasByAdmin";
import FC from "../pages/clients/DF/FC";
import DFEnterprises from "../pages/clients/DF/DFEnterprises";
import Contratos from "../pages/clients/Contratos";
import ContratosAdmin from "../pages/ContratosAdmin";

function AppRouter() {
	return (
		<Routes>
			<Route path="/" element={<HomePage />} />
			<Route path="/login" element={<Login />} />
			<Route path="/dashboard" element={<PrivateRoute> <Dashboard /></PrivateRoute>} />
			<Route path="/avisos" element={<PrivateRoute> <Anuncios /></PrivateRoute>} />
			<Route path="/admins" element={<PrivateRoute> <Admins /></PrivateRoute>} />
			<Route path="/usuariosRS" element={<PrivateRoute> <UsuariosRS /></PrivateRoute>} />
			<Route path="/avisosyblog" element={<PrivateRoute> <AvisosYBlog /></PrivateRoute>} />
			<Route path="/usuarios" element={<PrivateRoute> <Usuarios /></PrivateRoute>} />
			<Route path="/leaders" element={<PrivateRoute> <Leaders /></PrivateRoute>} />
			<Route path="/contadores" element={<PrivateRoute> <Contadores /></PrivateRoute>} />
			<Route path="/clientes" element={<PrivateRoute> <Clientes /></PrivateRoute>} />
			<Route path="/df_usuarios" element={<PrivateRoute> <Abogados /></PrivateRoute>} />
			<Route path="/empresa" element={<PrivateRoute> <EmpresaList /></PrivateRoute>} />
			<Route path="/contratosAdmin" element={<PrivateRoute> <ContratosAdmin /></PrivateRoute>} />
			<Route path="/perfil" element={<PrivateRoute> <Perfil /></PrivateRoute>} />
			<Route path="/clientes/empresas/:id" element={<PrivateRoute> <Empresas /></PrivateRoute>} />
			<Route path="/clientes_df" element={<PrivateRoute> <DFEnterprises /></PrivateRoute>} />
			<Route path="/clientes/empresas/:id/decide" element={<PrivateRoute> <EmpresaDecide /></PrivateRoute>} />
			<Route path="/clientes/empresas/:id/defensa_fiscal" element={<PrivateRoute> <DF /></PrivateRoute>} />
			<Route path="/clientes/empresas/:id/defensa_fiscal/:caso_id" element={<PrivateRoute> <DFMenu /></PrivateRoute>} />
			<Route path="/clientes/empresas/:id/defensa_fiscal/:caso_id/:etapa" element={<PrivateRoute> <DFEtapa /> </PrivateRoute>} />
			<Route path="/clientes/empresas/:id/defensa_fiscal/:caso_id/fc" element={<PrivateRoute> <FC /> </PrivateRoute>} />
			<Route path="/empresas" element={<PrivateRoute> <EmpresasContador /></PrivateRoute>} />
			<Route path="/clientes/empresas/:id/:tabla" element={<PrivateRoute> <MenuDoc /></PrivateRoute>} />
			<Route path="/clientes/empresas/:id/:tabla/:tipo" element={<PrivateRoute> <Documentos /></PrivateRoute>} />
			<Route path="/clientes/empresas/:id/reuniones" element={<PrivateRoute> <Reuniones /></PrivateRoute>} />
			<Route path="/clientes/empresas/:id/herramientas" element={<PrivateRoute> <Herramientas /></PrivateRoute>} />
			<Route path="/clientes/empresas/:id/estado_cuenta" element={<PrivateRoute> <EstadoDeCuenta /></PrivateRoute>} />
			<Route path="/clientes/empresas/:id/contratos" element={<PrivateRoute> <Contratos /> </PrivateRoute>} />
			<Route path="/organigrama" element={<PrivateRoute> <OrganigramaPage /></PrivateRoute>} />
			<Route path="/encuesta/:token" element={<Encuesta />} />
			<Route path="/contador/:id/empresas" element={<PrivateRoute> <EmpresasContadorAdminTemplate /></PrivateRoute>} />
			<Route path="/empresasAdmin" element={<PrivateRoute> <EmpresasAdmin /> </PrivateRoute>} />
			<Route path="/empresasByAdmin/:adminId" element={<PrivateRoute> <EmpresasByAdmin /> </PrivateRoute>} />
			<Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
}

export default AppRouter;
